import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as PreviewArrowSVG } from "go-core/images/svg/actions/preview-arrow.svg";

interface Props {
	link: string;
	title: string;
	description?: string;
	icon?: JSX.Element;
}

const ChurnItem = ({ link, title, description, icon }: Props) => {
	return (
		<>
			<Link
				to={link}
				rel="noreferrer"
				target="_blank"
				className="d-flex justify-content-between align-items-center churn-item"
			>
				<div className="d-flex churn-item-inner">
					{icon}
					<div className="d-flex flex-column title-box">
						<span>{title}</span>
						<small className="text-muted">{description}</small>
					</div>
				</div>
				<PreviewArrowSVG className="ms-1" />
			</Link>
			<hr />
		</>
	);
};

export default ChurnItem;
